export default __webpack_public_path__ + "static/card6-70d38cf1c03f860446177d9e7c78f832.webp";